/* eslint-disable */
var domutils = require('../domutils');
var mutils = require('../math-utils');

var domElement = {
  amount: {
    total: domutils.qclass('total-amount')[0],
    toPay: domutils.qclass('to-pay-amount')[0]
  },
  payment: {
    form: domutils.qid('form-payment-method'),
    paymentSelect: domutils.q('#paymentMethod', this.form),
    continuePart: domutils.q('.continue-form-part', this.form),
    placeOrderPart: domutils.q('.place-order-form-part', this.form),
    info: domutils.qclass('giftcard-list-info')[0],
    paymentTabs: domutils.qid('payment-types'),
    paymentTabsHeader: domutils.q('[data-item="paymentTabsHeader"]')
  },
  messageBox: domutils.qclass('giftcard-message-box')[0]
};

var data = {
  prices: {},
  firstLoad: true
};


var loadValuesFromTemplate = function() {
  var globalPrices = window.BasketPrices;
  data.prices = {
    parts: {
      discount: globalPrices.fTotalDiscount,
      services: globalPrices.fTotalServices,
      delivery: globalPrices.fTotalDelivery,
      support: globalPrices.fTotalSupport,
      monthlySupport: globalPrices.fMonthlySupport,
      items: globalPrices.fTotalPrice,
      giftCards: 0
    },
    total: 0,
    toPay: 0 //computed in recalculate method
  };
};

/**
 * Recalculate all sum prices according to particular items prices and return them out
 * @return {{total: {number}, toPay: {number}}}
 */
var recalculate = function() {
  var previousToPayAmount = data.prices.toPay;

  data.prices.total = data.prices.parts.items + data.prices.parts.delivery + data.prices.parts.support + data.prices.parts.services - data.prices.parts.discount;
  domElement.amount.total.innerHTML = mutils.priceFormat(data.prices.total);

  data.prices.toPay = mutils.priceRound(data.prices.total - data.prices.parts.giftCards);
  domElement.amount.toPay.innerHTML = mutils.priceFormat(data.prices.toPay);

  if (data.prices.toPay !== previousToPayAmount && data.firstLoad === false) {
    $(document).trigger('toPayAmountChanged', {
      toPay: data.prices.toPay
    });
  }
  // Avoid multiple flexometer iframe inits during page load. Without firstLoad there was
  // unnecessarily fired event which refreshed flexometer. This event is used only by flexometer.
  data.firstLoad = false;

  if (data.prices.toPay === 0) {
    domutils.show(domElement.payment.placeOrderPart);
    domutils.hide(domElement.payment.continuePart);
    domutils.disable(domElement.payment.paymentSelect);
    totalPrices.messages.show(window.translate.giftcard_clickPlaceOrder, window.translate.giftcard_paid);
    if (domElement.payment.paymentTabs) { // If payment tabs are turned on
      domutils.removeClass(domElement.payment.form, 'desktop-only');
      domutils.addClass(domElement.payment.paymentTabsHeader, 'mobile-only');
      domutils.hide(domElement.payment.paymentTabs);
    }
  } else {
    domutils.show(domElement.payment.continuePart);
    domutils.hide(domElement.payment.placeOrderPart);
    domutils.enable(domElement.payment.paymentSelect);
    totalPrices.messages.hide();
    if (domElement.payment.paymentTabs) { // If payment tabs are turned on
      domutils.show(domElement.payment.paymentTabs);
      domutils.addClass(domElement.payment.form, 'desktop-only');
      domutils.removeClass(domElement.payment.paymentTabsHeader, 'mobile-only');
    }
  }
  return {
    total: data.prices.total,
    toPay: data.prices.toPay
  }
};


var totalPrices = {
  init: function() {
    loadValuesFromTemplate();
    recalculate();
  },  
  messages: {
    /**
     * Show messages next to Amoun to pay box and in payment info
     * (ex.: click on place order, whole amount paid)
     * @param {string} message
     */
    show: function(boxMessage, infoMessage) {
      this.hide();
      setTimeout(function() {
        domElement.messageBox.innerHTML = boxMessage;
        domElement.payment.info.innerHTML = infoMessage;        
        domutils.show(domElement.messageBox);
        domutils.show(domElement.payment.info);
      }, 150);
    },
    hide: function() {
      domutils.hide(domElement.messageBox);
      domutils.hide(domElement.payment.info);
    }    
  },
  update: {
    discount: function(amount) {
      data.prices.parts.discount = amount;
    },
    giftCards: function(amount) {
      data.prices.parts.giftCards = amount;
    }
  },
  get: {
    total: function() {
      return data.prices.total;
    },
    support: function() {
      return data.prices.parts.support;
    },
    monthlySupport: function() {
      return data.prices.parts.monthlySupport;
    },
    toPay: function() {
      return data.prices.toPay;
    },
    toPayWithoutSupport: function() {
      return this.toPay() - this.monthlySupport();
    }
  },
  recalculate: recalculate
};

module.exports = totalPrices;
